import { api } from '@/api/api';
export class MaterielApiImpl {
    constructor() {
        this.name = 'materielApiImpl';
        this.http = api.getDataTransApi();
        this.eventApi = api.getEventApi();
        this.systemApi = api.getSystemApi();
    }
    init() {
        return this.name;
    }
    errorHandler(error) {
        var _a;
        this.eventApi.sendSysEvent({
            auto: true,
            eventSeq: 0,
            eventName: 'error',
            eventLevel: 'error',
            eventData: {
                title: ((_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.message) || (error === null || error === void 0 ? void 0 : error.message) || '网络错误',
                content: '',
                popupType: 'toast',
                popupLevel: 'error',
            },
        });
    }
    async get(url, req, config) {
        try {
            const { data } = await this.http.get(url, req, config);
            if (!data)
                throw {};
            if (!data.success) {
                throw data;
            }
            return data.data;
        }
        catch (error) {
            const { toastError = true } = config || {};
            toastError && this.errorHandler(error);
            return Promise.reject(error);
        }
    }
    async post(url, body, config) {
        config = Object.assign({ contentType: 'json', noEnqueue: false }, (config || {}));
        try {
            const { data } = await this.http.post(url, body, config);
            if (!data)
                throw {};
            if (!data.success) {
                throw data;
            }
            return data.data;
        }
        catch (error) {
            const { toastError = true } = config || {};
            toastError && this.errorHandler(error);
            return Promise.reject(error);
        }
    }
    async delete(url, req, config) {
        try {
            const { data } = await this.http.delete(url, req, config);
            if (!data)
                throw {};
            if (!data.success) {
                throw data;
            }
            return data.data;
        }
        catch (error) {
            const { toastError = true } = config || {};
            toastError && this.errorHandler(error);
            return Promise.reject(error);
        }
    }
    getUploadToken(req) {
        return this.get(this.systemApi.getUrl('getMaterielUploadToken'), req);
    }
    getDownloadUrl(req) {
        return this.post(this.systemApi.getUrl('getMaterielDownloadUrl'), req);
    }
    getPreviewUrl(req) {
        return this.post(this.systemApi.getUrl('getMaterielPreviewUrl'), req);
    }
    addFile(req) {
        return this.post(this.systemApi.getUrl('addMaterielFile'), req);
    }
    deleteFile(req) {
        return this.get(this.systemApi.getUrl('deleteMaterielFile'), req);
    }
    renameFile(req) {
        return this.get(this.systemApi.getUrl('renameMaterielFile'), req);
    }
    getFileList(req) {
        return this.get(this.systemApi.getUrl('getMaterielFileList'), req);
    }
    getShareList(req) {
        return this.get(this.systemApi.getUrl('getMaterielShareList'), req);
    }
    getShareAccounts() {
        return this.get(this.systemApi.getUrl('getMaterielShareAccounts'));
    }
    getSharePreview(req) {
        return this.get(this.systemApi.getUrl('getMaterielSharePreview'), req);
    }
    editShare(req) {
        return this.post(this.systemApi.getUrl('editMaterielShare'), req);
    }
    reportWaShare(req) {
        return this.post(this.systemApi.getUrl('reportMaterielWaShare'), req);
    }
    getBusinessCard(req) {
        return this.get(this.systemApi.getUrl('getMaterielBusinessCard'), req);
    }
    editBusinessCard(req) {
        return this.post(this.systemApi.getUrl('editMaterielBusinessCard'), req);
    }
    getWAShareList(req) {
        return this.get(this.systemApi.getUrl('getWAShareList'), req);
    }
    getShareVisitList(req) {
        return this.get(this.systemApi.getUrl('getShareVisitList'), req);
    }
}
const materielApi = new MaterielApiImpl();
api.registerLogicalApi(materielApi);
export default materielApi;
